import moment from 'moment-jalaali';

export function formatDatetimeObject(obj) {
  const date = moment(`${obj.year}/${obj.month}/${obj.day} 12:00`, 'jYYYY/jM/jD HH:mm');
  return date.format('YYYY-MM-DD');
}

export function convertDatetimeToObject(datetime = null) {
  const m = datetime ? moment(`${datetime} 12:00`, 'YYYY-MM-DD HH:mm') : moment();
  return {day: m.jDate(), month: m.jMonth() + 1, year: m.jYear()};
}
